'use client';

import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { cn } from '@/shared/utils/cn';

export const Field = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(
  ({ className, children, ...props }, ref) => (
    <div ref={ref} className={cn(className)} {...props}>
      {children}
    </div>
  ),
);
Field.displayName = 'Field';
